module.exports = __webpack_public_path__ + "img/FF_Asset_Info_Web_2.610ac551.png";